import styled from 'styled-components';
import { Typography } from '@mui/material';
import { ReactComponent as TreeGraphic } from '../../assets/tree-graphic.svg';
import { FlexCenter, FlexColumn } from '../Flex';
import { fontWeight, radius, shadow } from '../../style/utils';

const PAGE_PADDING = '56px';
const PAGE_GAP = '28px';

const Wrapper = styled(FlexColumn)`
  width: 456px;
  height: 400px;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.palette.surface.base};
  border: 1px solid ${({ theme }) => theme.palette.border.light};
  padding: ${PAGE_PADDING};
  gap: ${PAGE_GAP};
  border-radius: ${radius('lg')};
  box-shadow: ${shadow('float')};
`;

const ContinueLink = styled.span`
  text-decoration: underline;
  cursor: pointer;
`;

type Props = {
  onContinue: () => void;
};

const SelectDatasetPage = ({ onContinue }: Props) => (
  <FlexCenter
    sx={{
      width: '100%',
      height: '100%',
    }}
  >
    <Wrapper>
      <FlexColumn sx={{ gap: 1, alignItems: 'center', background: 'none' }}>
        <Typography sx={{ fontWeight: fontWeight('semibold') }}>
          Select a subfolder or filter
        </Typography>
        <Typography sx={{ color: 'content.secondary' }}>
          You are trying to load a large amount of assets.
        </Typography>
      </FlexColumn>
      <TreeGraphic />
      <Typography sx={{ color: 'content.secondary' }}>
        Or{' '}
        <ContinueLink onClick={onContinue}>
          continue to view lineage
        </ContinueLink>
      </Typography>
    </Wrapper>
  </FlexCenter>
);

export default SelectDatasetPage;
